module.exports = __webpack_public_path__ + "img/ng.14890897.svg";